import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { connect } from 'react-redux';
import * as queryString from 'query-string';
import { deleteSkill } from '../../redux/reduxActions/actions';
import { deleteDone } from '../../redux/reduxActions/planActions';
import Paginator from '../componentsUI/Paginator';
import { getEventList } from '../../redux/reduxActions/planActions';
import {Button, Modal} from "react-bootstrap";
import { ReactComponent as DeletePlanIcon } from '../../assets/svg/delete_plan.svg';
function SkillTable(props) {
	const {
		eventPlanList, responsible, eventTypes, funnelType,
	} = props;
  const [plansItemPerPage, setPlansItemPerPage] = useState('20');
  const [activePage, setActivePage] = useState(1);
  const [activeDeletePopup, setActiveDeletePopup] = useState(false);
  const [selectedPlanDelete, setSelectedPlanDelete] = useState([]);
  useEffect(() => {
	  const parsed = queryString.parse(props.location.search);
	  if (Object.keys(parsed).length) {
		  setPlansItemPerPage(parsed.limit ? parsed.limit.toString() : '20');
		  setActivePage(parsed.page ? parseInt(parsed.page, 10) : 1);
		  props.getEventList({
        page: parsed.page || plansItemPerPage,
			  limit: parsed.limit || activePage,
      });
	  }
	  props.getEventList();
  }, []);
  const setPaginator = (limit, page) => {
	  setPlansItemPerPage(limit);
	  setActivePage(page);
	  props.getEventList({ page, limit });
	  const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?page=${page}&limit=${limit}`;
	  if (window.history.pushState) {
		  window.history.pushState({ path: newUrl }, '', newUrl);
	  }
  };
  function deletePopup(original) {
	  setSelectedPlanDelete(original);
	  setActiveDeletePopup(!activeDeletePopup)
	  //props.deleteDone(original.id);
  }
  function deletePlan() {
	// console.log(selectedPlanDelete.id);
	props.deleteDone(selectedPlanDelete.id);
}
	const skillsTableAdmin = [
		{
			Header: '#',
			id: 'row',
			maxWidth: 50,
			filterable: false,
			Cell: (row) => (<div>{row.index}</div>),
		},
		{
			Header: 'Date',
			accessor: 'day',
			maxWidth: 120,
		},
		{
			Header: 'Funnel Type',
			Cell: ({ original }) => {
				const title = funnelType.find((item) => item.id === original.funnel_type);
				const { name } = title || { name: '' };
				return (
					<p>{name}</p>
				);
			},
		},
		{
			Header: 'Event Type',
			Cell: ({ original }) => {
				const selectedItem = eventTypes.find((item) => item.id === original.event_type);
				const { title } = selectedItem || { name: '' };
				return (
					<p>{title}</p>
				);
			},
		},
		{
			Header: 'Responsible',
			Cell: ({ original }) => {
				const selectedItem = responsible[original.responsible];
				return (
					<p>{selectedItem}</p>
				);
			},
		},
		{
			Header: 'Amount',
			accessor: 'amount',
			maxWidth: 120,
		},
		{
			Cell: ({ original }) => (
				<Button disabled={!eventPlanList.can_delete} onClick={() => deletePopup (original)}  variant={eventPlanList.can_delete ? 'btn btn-outline-danger' : 'btn btn-outline-seconadary'}><DeletePlanIcon style={{ marginLeft: '3px' }}/></Button>
			),
			Header: 'Delete',
			className: 'centered',
			width: 70,
		}
	];
  return (
    <div style={{ margin: '50px 15px 15px 15px' }}>
		<Modal  show={activeDeletePopup} onHide="true">
			<div style={{ margin: 20 }}>
                <div>
                    <h3>
                        Are you shure you want to delete this plan for the day {selectedPlanDelete.day} ?
                    </h3>
				</div>
			</div>
			<Modal.Footer>
                <Button
                    variant="secondary"
					onClick={() => setActiveDeletePopup(!activeDeletePopup)}
                >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    className="main-button-filled"
					onClick={deletePlan}
                >
                    Delete
                </Button>
            </Modal.Footer>
		</Modal>
      <h3 style={{ color: '#383838', marginBottom: 10, marginLeft: 15 }}>Plan</h3>
		<ReactTable
        data={eventPlanList.data}
        columns={skillsTableAdmin}
        style={{
				  marginTop: '10px',
        }}
        minRows={4}
        showPagination={false}
        className="-striped -highlight"
      />
      <Paginator
        itemsPerPage={plansItemPerPage}
        activePage={activePage}
        totalItemsCount={eventPlanList.total}
        setFilters={setPaginator}
      />
    </div>
  );
}

const mapStateToPropsTable = (state) => ({
  eventPlanList: state.planReducer.eventPlanList,
  responsible: state.leadReducer.responsible,
  eventTypes: state.planReducer.eventTypes,
  funnelType: state.leadReducer.funnelType,
});
export default connect(mapStateToPropsTable, { deleteSkill, getEventList,deleteDone })(SkillTable);
